module.exports = __webpack_public_path__ + "img/shape_landing_comofunciona_6.cff08b56.svg";